<template>
  <header class="pos-header">
    <div class="logo">
      <i class="el-icon-s-shop"></i> {{ systemInfo.systemSimpleTitle }} {{ systemInfo.version }}
    </div>
    <div class="status-bar">
      操作员: {{ username }} | <span>{{ currentTime }}</span>
    </div>
  </header>
</template>

<script>
import { getUserInfo } from '@/api/user/indexApi'
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import config from '@/conf/config'

export default {
  name: 'PosHeader',
  data() {
    return {
      username: '',
      currentTime: '12:00',
      systemInfo: {
        systemSimpleTitle: '',
        version: ''
      }
    }
  },
  async created() {
    await this.loadUserInfo()
    await this.loadSystemInfo()
    this.systemInfo.version = config.version
  },
  mounted() {
    this.updateTime()
    this.timer = setInterval(() => {
      this.updateTime()
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    async loadUserInfo() {
      try {
        const user = await getUserInfo()
        this.username = user.name || ''
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },
    async loadSystemInfo() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 })
        if (data && data.length > 0) {
          this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle || ''
        }
      } catch (error) {
        console.error('获取系统信息失败:', error)
      }
    },
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleTimeString().slice(0, 5)
    }
  }
}
</script>

<style scoped>
.pos-header {
  background: #1e293b;
  height: 50px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.logo {
  font-weight: bold;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-bar {
  font-size: 0.9rem;
}
</style>

